@import "@/styles/variables";

.cardPanel {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0.75rem;
}

.alerts {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.alertItem {
	margin: 0;
}

.toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	width: 100%;
	flex-wrap: wrap;
}

.toolbarActions {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.sectionTitle {
	margin: 0;
	font-size: 0.95rem;
	font-weight: 600;
	color: $gray-700;
}

.sectionSubtitle {
	margin: 0.15rem 0 0;
	font-size: 0.75rem;
	color: $gray-500;
}

.form {
	display: grid;
	grid-template-columns: minmax(150px, 200px) minmax(150px, 200px) auto;
	grid-template-rows: auto 36px;
	column-gap: 0.75rem;
	row-gap: 0.25rem;
	align-items: center;
	padding-top: 0.75rem;
	border-top: 1px solid $gray-100;

	@media (max-width: 640px) {
		grid-template-columns: 1fr;
		grid-template-rows: auto;
	}
}

.formLabel,
.formLabelPlaceholder {
	font-size: 0.75rem;
	font-weight: 600;
	line-height: 1.2;
}

.formLabel {
	color: $gray-500;
}

.formLabelPlaceholder {
	visibility: hidden;
	user-select: none;
}

.dateInput,
.formConfirmButton {
	box-sizing: border-box;
	width: 100%;
	height: 36px;
	min-height: 36px;
	margin: 0;
}

.dateInput {
	padding: 0 0.65rem;
	font-size: 0.875rem;
	font-family: inherit;
	border: 1px solid $gray-300;
	border-radius: 8px;
	background: #ffffff;
	color: $gray-700;

	&:focus {
		outline: none;
		border-color: $primary-color;
	}
}

.formConfirmButton {
	justify-self: start;
	width: auto;
	padding: 0 0.875rem;
	line-height: 1;
}

.actions {
	display: flex;
	justify-content: flex-end;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.clickable {
	cursor: pointer;

	&:hover {
		opacity: 0.85;
	}
}
